module.exports = __webpack_public_path__ + "img/aeroland-payment-box-icon-03.9ea9dfc9.png";